/**
 * Helpers pentru linkuri de navigație bazate pe adresă text.
 * Sursa adresei este aceeași cu cea folosită de harta Google Maps de pe pagina anunțului,
 * ca link-ul de navigație și harta să indice mereu același loc.
 */

/** Link Waze cu adresă text (fără geocodare, fără lat/lng). */
export function buildWazeLink(address?: string | null): string | null {
  const clean = (address || '').trim();
  if (!clean) return null;
  return `https://waze.com/ul?q=${encodeURIComponent(clean)}&navigate=yes`;
}

/** Link Google Maps cu adresă text (aceeași sursă ca Waze). */
export function buildGoogleMapsLink(address?: string | null): string | null {
  const clean = (address || '').trim();
  if (!clean) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clean)}`;
}
